import React from "react";
import { Redirect, useLocation } from "react-router";
import LoadingModal from "src/modes/Electric/LoadingModal";
import useSelector from "src/utils/useSelector";

export default function LockedPricingDefaultRoute() {
    const isAppOpen = useSelector((state) => state.onlineShopper.isAppOpen);
    const isAuthed = useSelector((state) => state.onlineShopper.isAuthed);
    const isGarageCreated = useSelector((state) => state.onlineShopper.garageCreated);
    const hasDeal = useSelector((state) => state.deal.uuid !== undefined);
    const hasVehicles = useSelector((state) => !!state.vehicles.order.length);
    const openToTradeIn = useSelector((state) => state.onlineShopper.tradeInOpen);
    const { state: locationState } = useLocation<{ fromUnlock?: boolean }>();
    const fromUnlock = !!locationState?.fromUnlock;
    const openToPreQual = useSelector((state) => state.onlineShopper.creditIQPrequalOpen);

    if (!isAppOpen) {
        return null;
    }

    if (!hasDeal || !hasVehicles) {
        return <LoadingModal />;
    }

    if (openToTradeIn) {
        return (
            <Redirect
                to={{
                    pathname: "payment-builder/trade-in",
                    state: { fromUnlock },
                }}
            />
        );
    }

    if (openToPreQual) {
        return <Redirect to="/payment-builder/prequal" />;
    }

    if (isAuthed && isGarageCreated) {
        return <Redirect to="/my-garage" />;
    }

    if (isAuthed) {
        return (
            <Redirect
                to={{
                    pathname: "/payment-builder",
                    state: { fromUnlock },
                }}
            />
        );
    }

    return <Redirect to="/create" />;
}
